import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { CommunicationAlertsResponse } from '../entities';
import { ICommunicationService } from '../entities/ICommunicationService';
import { ICommunicationRepository } from '../entities/ICommunicationRepository';

export class CommunicationServiceImpl implements ICommunicationService {
  itemRepo: ICommunicationRepository;

  constructor(ir: ICommunicationRepository) {
    this.itemRepo = ir;
    this.GetCommunicationAlerts = this.GetCommunicationAlerts.bind(this);
    this.UpdateCommunicationByCategory = this.UpdateCommunicationByCategory.bind(this);
    this.UpdateCommunicationByTask = this.UpdateCommunicationByTask.bind(this);
  }

  GetCommunicationAlerts(data: { customerId: string }): Promise<CommunicationAlertsResponse> {
    return this.itemRepo.GetCommunicationAlerts(data.customerId);
  }

  UpdateCommunicationByCategory(data: {
    headerId: string;
    categoryId: string;
    email: boolean;
    sms: boolean;
    notification: boolean;
    successCallback: SuccessCallback;
  }): Promise<{}> {
    return this.itemRepo.UpdateCommunicationByCategory(
      data.headerId,
      data.categoryId,
      data.email,
      data.sms,
      data.notification,
      data.successCallback,
    );
  }

  UpdateCommunicationByTask(data: {
    headerId: string;
    categoryId: string;
    taskId: string;
    email: boolean;
    sms: boolean;
    notification: boolean;
    successCallback: SuccessCallback;
  }): Promise<{}> {
    return this.itemRepo.UpdateCommunicationByTask(
      data.headerId,
      data.categoryId,
      data.taskId,
      data.email,
      data.sms,
      data.notification,
      data.successCallback,
    );
  }
}
